<template>
  <div class="group-listing">
    <div class="mb-12">
      <v-row class="flex-column flex-md-row">
        <v-col>
          <v-card-title
            class="display-2 letter-spacing-compact font-weight-bold mb-md-12 align-center px-5"
          >
            {{ 'Offline Custom Trips' }}
          </v-card-title>
        </v-col>
        <v-col>
          <v-row class="align-md-center">
            <v-col>
              <v-text-field
                append-icon="$search"
                label="Search"
                v-model="search"
                class="px-5 mt-0 mt-md-1 pt-0 pt-md-3"
              />
            </v-col>
          </v-row>
          <v-row v-if="onlineStatus">
            <v-col>
              <v-card-actions class="px-5">
                <v-alert density="compact" type="info" icon="$info">
                  You are online!
                  <v-icon color="default" size="16px" class="ml-1">
                    $wifi
                  </v-icon>
                  <v-btn
                    depressed
                    small
                    link
                    @click="redirectToDashboard"
                    class="ml-1"
                  >
                    {{ isValidLogin ? 'Go to dashboard' : 'Login' }}
                  </v-btn>
                </v-alert>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="flex">
          <v-btn
            depressed
            large
            color="primary"
            class="white--text ml-5 mt-2"
            @click="newOfflineTrip()"
          >
            {{ 'New Trip' }}
            <v-icon class="ml-3" right>
              $plus
            </v-icon>
          </v-btn>

          <v-btn
            v-if="groups.length && onlineStatus"
            depressed
            large
            color="success"
            class="white--text ml-5 mt-2"
            @click="showBulkCheckout"
          >
            {{ 'Bulk Checkout' }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :fixed-header="false"
        class="primary-table border-radius-0 data-table v-data-table-1 v-data-table-1--style2 withaction mt-10"
        :headers="headers"
        :items="groups"
        loading-text="fetching data..."
        no-data-text="No data"
        no-results-text="Unable to find any data"
        :options.sync="pagination"
        :items-per-page="pagination.itemsPerPage"
      >
        <template v-slot:item.check_in="{ value }">
          {{ value ? $moment(value).format('DD/MM/YY') : '' }}
        </template>
        <template v-slot:item.check_out="{ value }">
          {{ value ? $moment(value).format('DD/MM/YY') : '' }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-row
            class="d-inline-flex  fill-height flex-fill align-center action-fill position-relative"
          >
            <v-divider class="position-absolute" vertical />
            <v-col class="pa-0">
              <v-btn
                text
                color="primary title"
                class="px-4"
                @click="handleEdit(item)"
              >
                Edit
              </v-btn>
              <v-btn
                v-if="onlineStatus"
                text
                color="primary title"
                class="px-4"
                @click="showCheckout(item)"
              >
                Checkout
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <transition name="slide">
      <component
        ref="drawer"
        @exit="closeDrawer"
        v-if="drawerView"
        :is="drawerView"
        :group="selectedGroup"
        @refresh="fetchData()"
      />
    </transition>
  </div>
</template>

<style>
@media only screen and (max-width: 959px) {
  .group-listing .v-data-table .v-data-table__mobile-table-row {
    display: table !important;
  }
}

@media only screen and (max-width: 959px) {
  .group-listing
    .v-data-table
    .v-data-table__mobile-table-row
    .v-data-table__mobile-row {
    display: table-cell !important;
  }
}

@media only screen and (max-width: 959px) {
  .group-listing
    .v-data-table
    .v-data-table__mobile-table-row
    .v-data-table__mobile-row {
    display: table-cell;
  }
}

@media only screen and (max-width: 599px) {
  .group-listing .v-data-table__wrapper > table tbody tr {
    width: 500px !important;
  }
}

@media only screen and (max-width: 959px) {
  .group-listing .v-data-table .v-data-table__mobile-table-row td:first-child {
    white-space: nowrap !important;
  }
}

@media only screen and (max-width: 959px) {
  .group-listing
    .v-data-table
    .v-data-table__mobile-table-row
    .v-data-table__mobile-row {
    width: 12%;
    white-space: nowrap;
  }
}
</style>

<script>
import Model from '@models/CustomGroup';
import Storage from '@services/Storage';
import { StoreNames } from '@constants/storage';

const storage = new Storage();

export default {
  name: 'OfflineTrips',
  metaInfo: {
    titleTemplate: '%s - Trips',
  },
  components: {
    BulkCheckout: () => import('./../offline-trips/_partials/BulkCheckout'),
  },
  data() {
    return {
      createMode: false,
      historyMode: this.$route.query.history === 'true',
      drawerView: '',
      selectedGroup: null,
      generalHeaders: [
        {
          text: 'Trip Name',
          value: 'name',
          sortable: false,
          width: 200,
        },
        { text: 'Check-in', value: 'check_in', width: 150 },
        { text: 'Check-out', value: 'check_out', width: 150 },
      ],
      pagination: {
        sortBy: ['created_at'],
        itemsPerPage: 10,
        page: 1,
        sortDesc: [true],
      },
      search: '',
      groups: [],
      model: new Model({
        filters: {
          id: this.$route.query.group_id || '',
        },
      }),
      total: 10,
      onlineStatus: navigator.onLine,
    };
  },
  computed: {
    headers() {
      let headers = this.generalHeaders.slice();

      headers.push({
        text: 'Actions',
        value: 'action',
        sortable: false,
      });

      return headers;
    },
    isValidLogin() {
      return localStorage.getItem('x-access-token') && this.currentUser;
    },
  },
  watch: {
    pagination: {
      handler(pagination) {
        Object.assign(this.model, pagination);
        this.fetchData();
      },
      deep: true,
    },
    search: {
      handler() {
        this.fetchData();
      },
      immediate: false,
    },
  },
  methods: {
    async fetchData() {
      let firstFetching = !this.model.fetched;
      let response = await storage.find(StoreNames.TRIPS, {
        searchTerm: this.search,
        searchSubject: 'name',
      });
      if (response) {
        this.groups = Object.values(response);
        if (firstFetching && this.model.filters.id) {
          this.model.removeFilter('id');
        }
        this.total = response.length;
      }
    },
    showCheckout(group) {
      this.selectedGroup = group;
      this.drawerView = 'BulkCheckout';
    },
    closeDrawer(data) {
      this.drawerView = '';
      data && this.fetchData();
    },
    newOfflineTrip() {
      this.$router.push({
        name: 'new-offline-trip',
      });
    },
    redirectToDashboard() {
      this.$router.push({ name: this.isValidLogin ? 'auth' : 'login' });
    },
    handleEdit(item) {
      this.$router.push({ name: 'edit-offline-trip', query: { id: item.id } });
    },
    showBulkCheckout() {
      this.selectedGroup = null;
      this.drawerView = 'BulkCheckout';
    },
  },
  mounted() {
    this.fetchData();

    $bus.$on('online', () => {
      this.onlineStatus = true;
    });
    $bus.$on('offline', () => {
      this.onlineStatus = false;
    });
  },
};
</script>
